<template>
  <div>
    <modal v-show="currentObject" size="md">
      <div slot="header">
        <button type="button" class="close" @click.prevent="updateItemClose">×</button>
        <h5 class="modal-title">{{$formatter.formatUser(currentObject)}}</h5>
      </div>
      <div slot="body">
        <user-form ref="userForm" v-if="currentObject" @updated="updateFinished" @created="updateFinished" :oid="currentObject.id" :fullWidth="true" :formOnly="true" :editModeInitial="true"></user-form>
      </div>
      <div slot="footer">
        <button type="button" @click.prevent="updateItemClose" class="btn btn-default legitRipple">Cancel</button>
        <button type="submit" @click.prevent="$refs.userForm.saveData()" class="btn btn-primary legitRipple">Save changes</button>
      </div>
    </modal>
    <div ref="list" class="datatable-scroll scrollable">
      <table class="dataTable table table-hover tasks-list text-nowrap" role="grid">
        <thead>
        <tr role="row">
          <th tabindex="0" rowspan="1" colspan="1" width="1%"></th>
          <th tabindex="0" rowspan="1" colspan="1" width="1%"></th>
          <th tabindex="0" rowspan="1" colspan="1">First name</th>
          <th tabindex="0" rowspan="1" colspan="1">Last Name</th>
          <th tabindex="0" rowspan="1" colspan="1">Email</th>
          <th tabindex="0" rowspan="1" colspan="1">Phone</th>
          <th tabindex="0" rowspan="1" colspan="1" v-if="_can('updateUser')"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="!items.length" class="active border-double">
          <td colspan="6" class="text-semibold text-center">No agents added</td>
        </tr>
        <tr v-for="(item, idx) in items" :key="item.id" role="row" v-bind:class="{'even': idx === 0 || idx % 2 === 0, 'odd': idx % 2}">
          <td><i
            class="icon-user cursor-pointer"
            @click.prevent="setRole(item.id)"
            :class="{
                'text-green': checkRole(item) === 'agencyAdmin',
                'text-orange': checkRole(item) === 'agencyAgent',
                'text-danger': checkRole(item) === 'agencyUnlicensedAgent'
                }"
            :title="roleTitle(checkRole(item))"
          ></i></td>
          <td>
            <div v-if="item.profile.logo"><img class="img-circle img-md" :src="item.profile.logo.preview"/></div>
            <div v-else><img class="img-circle img-md" :src="require('@/assets/images/placeholder.jpg')"/></div>
          </td>
          <td>{{item.profile.first_name}}</td>
          <td>{{item.profile.last_name}}</td>
          <td>{{item.email}}</td>
          <td>{{item.profile.phone}}</td>
          <td>
            <ul class="icons-list" v-if="_can('updateUser')">
              <li><a @click.prevent="updateItemOpen(item.id)"><i class="icon-pencil"></i></a></li>
              <li><a @click.prevent="setPassword(item.id)"><i class="icon-key"></i></a></li>
              <li><a @click.prevent="deleteItem(item.id)"><i class="icon-trash"></i></a></li>
              <!-- li class="dropdown">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false" title="Assign role">
                  <i class="icon-cog7"></i>
                  <span class="caret"></span>
                </a>
                <ul class="dropdown-menu">
                  <li><a href="#">Agent</a></li>
                  <li><a href="#">Senior Agent</a></li>
                </ul>
              </li -->
            </ul>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import AgencyService from '@/services/agency.service'
import Modal from '@/components/Modal'
import UserForm from '@/components/configuration/users/Form'

export default {
  name: 'AgencyAgents',
  components: {UserForm, Modal},

  props: {
    'items': {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    },
    'parent': {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      object: {},
      idFilter: [],
      currentObject: false,
      localizedFormat: {},
      /** service **/
      service: AgencyService,
      statuses: [],
      systemStatuses: [],
      mode: {
        statusMap: {},
        resetAfterMount: false
      },
      /** **/
      objectState: {},
      /** **/
      drawComponent: true
    }
  },

  computed: {},

  beforeMount () {
    this.localizedFormat = Vue.config.localizedFormat
    if (this.mode.resetAfterMount) {
      this.reset(true)
    }
    this.mode.statusMap = Vue.config.statusMap
    this.systemStatuses = Vue.config.statuses
    this.statuses = []
  },

  watch: {
    '$route': 'flushObjectIfRequired'
  },

  mounted () {
    // let promises = []
    this.refresh()
    this.mode.resetAfterMount = false
  },

  methods: {
    checkRole (user) {
      if (this.parent) {
        for (let ua in user.userAgencies.filter(a => a.agency_id === this.parent.id)) {
          return user.userAgencies[ua].role
        }
      }
      return ''
    },

    roleTitle (role) {
      switch (role) {
        case 'agencyAdmin':
          return 'Senior Agent'
        case 'agencyAgent':
          return 'Agent'
        case 'agencyUnlicensedAgent':
          return 'Unlicensed Agent'
        default:
      }
      return '(not set)'
    },

    getById (id) {
      let result = this.items.filter(i => i.id === id)
      if (Array.isArray(result) && result.length) {
        return result[0]
      }
      return false
    },

    flushObjectIfRequired () {
      console.log(this.$route)
      this.$emit('shown', this.object)
      this.hardReset()
    },

    hardReset () {
      let vm = this
      vm.drawComponent = false
      Vue.nextTick(() => {
        vm.drawComponent = true
      })
    },

    reset (forceItemReset = true) {
      this.hasChanges = false
      this.$emit('reset', forceItemReset)
      if (forceItemReset) {
        this.flushObjectIfRequired()
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
      }
    },

    refresh (newInstance) {
      this.$emit('shown', this.object)
    },

    setItemStatus (item, status) {
      this.service.update(item, {'id': item, 'status': status}, result => {
        this.service.item(result.id).then(newdata => {
          this.refresh(newdata)
          this.hasChanges = true
          this.hasChanges = false
        })
      }, () => {
        this.$popup.warning('Can\'t set item STATUS on server')
      })
    },

    deleteItem (id) {
      this.$popup.confirm('Are you sure to remove this participant from Agency?', 'Confirm').then(() => {
        this.service.deleteAgent(this.parent.id, id, (result) => {
          console.log('Agent removed', result)
          this.$emit('item:deleted', true)
        })
      })
    },

    updateFinished () {
      this.$emit('item:changed', true)
      this.updateItemClose()
      this.$popup.success('Agent data successfully updated')
    },

    updateItemOpen (id) {
      this.currentObject = this.getById(id)
    },

    updateItemClose () {
      this.currentObject = false
    },

    setPassword (id, pass) {
      this.$popup.inputPassword('Set user password', 'Enter password').then((val) => {
        this.service.setPassword(this.parent.id, id, val, (result) => {
          this.$emit('item:changed', true)
        })
      })
    },

    setRole (id, role) {
      console.log(this.object.role)
      this.$popup.inputRadio({'agencyUnlicensedAgent': 'Unlicensed agent', 'agencyAgent': 'Agent', 'agencyAdmin': 'Senior agent'}, 'Set user role', this.checkRole(this.getById(id))).then((val) => {
        this.service.setRole(this.parent.id, id, val, (result) => {
          this.$emit('item:changed', true)
        })
      })
    },

    enterEditMode () {
      this.editMode = true
      this.showForm = false
      this.showForm = true

      this.objectState = Object.assign({}, this.object)
    },

    cancelEditMode () {
      this.editMode = false
      this.showForm = false
      this.showForm = true

      this.object = this.objectState
      this.$forceUpdate()
    },

    prepareData (obj) {
      let result = Object.assign({}, obj)
      return result
    },

    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    makeIdFilter () {
      this.idFilter = []
    },

    /** action methods **/
    setLogo (image) {
      this.object = Object.assign(this.object, {
        logo: image || null
      })
      this.object.logo_image_id = image.id || null
      this.$forceUpdate()
    },

    removeLogo () {
      this.object.logo = null
      this.object.logo_image_id = null
      this.$forceUpdate()
    },

    uploadComplete (file) {
      this.$logger.log('uploadComplete', file)
      this.setLogo(file.uploaded.image || null)
    },

    uploadError (file) {
      this.$logger.log('uploadError', file)
      this.$popup.warning('Failed to upload file')
    }

    /** sub-action methods **/
  },
  beforeDestroy () {
    this.object = {}
  }
}
</script>

<style scoped>

</style>
